import {
  useState,
  useEffect,
  forwardRef,
  Ref,
  useImperativeHandle,
} from "react";
import { Button } from "reactstrap";

import RichTextEditorV2 from "../CRM/RichTextEditorV2";
import AppDrawer from "../Drawers/AppDrawer";

interface Props {
  defaultValue: string | { RichText: string; PlainText: string };
  field: any;
  onChange: (field: any, value: string) => void;
  disabled: boolean;
}

const RichTextCreate = (
  { defaultValue, field, onChange, disabled }: Props,
  ref?: Ref<HTMLInputElement>
) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");

  const handleChange = () => {
    onChange(field, value);
    setOpen(false);
  };

  const handleDefaultValue = () => {
    if (defaultValue && typeof defaultValue === "object") {
      setValue(defaultValue.RichText);
    } else {
      setValue(defaultValue || "");
    }
  };

  const handleCancel = () => {
    handleDefaultValue();
    setOpen(false);
  };

  useEffect(() => {
    if (!defaultValue) return setValue(defaultValue);

    handleDefaultValue();
  }, [defaultValue]);

  // @ts-ignore
  useImperativeHandle(ref, () => ({
    focus: () => {
      setOpen(true);
    },
  }));

  return (
    <>
      <div
        style={{
          height: "calc( 0.45em + 1.25rem + 5px)",
          borderRadius: "0.25rem",
          fontSize: "0.875rem",
          lineHeight: 1.5,
          padding: "0.25rem 0.5rem",
          overflowY: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          background: disabled ? "#c6cac7" : "unset",
          cursor: disabled ? "not-allowed" : "pointer",
        }}
        className="border"
        onClick={disabled ? undefined : () => setOpen(true)}
      >
        {value ? "Click To Edit" : "--"}
      </div>
      <AppDrawer
        size="md"
        open={open}
        onClose={handleCancel}
        headerTitle={field.Name}
        headerOptions={
          <Button color="primary" onClick={handleChange}>
            Save
          </Button>
        }
        bodyCSS="pt-4"
        body={
          <RichTextEditorV2
            isEditing={true}
            value={value}
            onChange={(val: string) => setValue(val)}
            css="h-100"
            style={{
              minHeight: 300,
              height: "100%",
              paddingBottom: 100,
            }}
          />
        }
      />
    </>
  );
};

export default forwardRef(RichTextCreate);
